import { render, staticRenderFns } from "./cover-image-alert.vue?vue&type=template&id=55b00d0a&scoped=true&"
import script from "./cover-image-alert.vue?vue&type=script&lang=js&"
export * from "./cover-image-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b00d0a",
  null
  
)

export default component.exports